module.exports = "/_next/static/images/pricing-plans-consulting-service-4-c3a7688ae3e2e314454b3cfd0320c0bc.webp";